// Dify 聊天机器人配置

export const DIFY_CONFIG = {
  // 本地 Dify 配置
  BASE_URL: process.env.REACT_APP_DIFY_BASE_URL || 'https://dify.bondex.com.cn',
  CHATBOT_ID: process.env.REACT_APP_DIFY_CHATBOT_ID || '8NfL88WfjITkHLNp',
  API_KEY: process.env.REACT_APP_DIFY_API_KEY || 'app-7T6I7lYsQIjhJdFJSh0bz4wH',
  
  // 默认设置
  DEFAULT_HEIGHT: '700px',
  MIN_HEIGHT: '600px',
  
  // 功能说明
  FEATURES: [
    '查询77张主数据表的字段定义和结构',
    '获取框架API接口的字段说明和用途', 
    '了解表与表、接口与接口之间的关联',
    '判断字段是否适合作为唯一标识',
    '指导数据模型构建和接口对接'
  ]
};

// 构建完整的聊天机器人URL
export const getChatbotUrl = (chatbotId = DIFY_CONFIG.CHATBOT_ID, baseUrl = DIFY_CONFIG.BASE_URL, includeToken = false) => {
  const url = `${baseUrl}/chatbot/${chatbotId}`;
  if (includeToken && DIFY_CONFIG.API_KEY) {
    return `${url}?token=${DIFY_CONFIG.API_KEY}`;
  }
  return url;
};

export default DIFY_CONFIG;